import { Context, createContext } from 'react';

import { TComponentsMapContext } from '../../../types';

const initialState: TComponentsMapContext = {
  componentsMap: {}
};

const ComponentsMapContext: Context<TComponentsMapContext> =
  createContext(initialState);

export default ComponentsMapContext;
